import { useMutation, useQueryClient } from '@tanstack/react-query'

import type { UpdateTags } from '../../types/tags'
import api from '../../api'

const useUpdateTags = (tagsID: string) => {
	const queryClient = useQueryClient()

	return useMutation({
		mutationFn: async (updateTags: UpdateTags) => {
		  try {
			  let response = await api.tags.updateTagsById(updateTags)
				if (!response.ok) {
				  throw new Error(`Status: ${response.status} ${response.statusText} from '/tags'`)
				}
				return response.json()
			}
			catch (error) {
			  throw error
			}
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ['tags'] })
			queryClient.invalidateQueries({
				queryKey: ['tags', tagsID]
			})
			// Invalidate accounts so any form using useSingleAccount or useAccounts
			// (e.g. ApprovalForm) automatically refetches the updated tags/systemAlias
			queryClient.invalidateQueries({ queryKey: ['accounts'] })
		},
		onError: (error, variables, context) => {
		  console.log(error)
			console.log(variables)
			console.log(context)
		}
	})
}

export default useUpdateTags
